import { Row, Col } from 'reactstrap';
import { useCallback } from 'react';
import _get from 'lodash/get';
import useRouter from 'use-react-router';

import NavigationGroupTabs from 'common/components/buttons/NavigationGroupTabs';
import TableSearchText from 'common/components/table/TableSearchText';

import paths from 'routing/routes/_paths';
import menuIcon from 'common/assets/svg/common/burger.svg';
import environmental from 'common/assets/svg/common/earth-solid.svg';
import { getInitialAsyncValues, getAsyncOptions } from 'utils/helpers';
import { useSelector } from 'react-redux';
import Select from 'common/components/form/inputs/Select';
import { selectListDefaultOptions } from 'store/lists/selectors';
import { useMemo } from 'react';
import { portNoAreaOption, portNoCountryOption } from 'views/enums/ports/form/port/constants';

const TopFilters = ({ topFilters, setTopFilters }) => {
  const areaslistOptions = useSelector(state => selectListDefaultOptions(state, 'port-areas'));

  const countrieslistOptions = useSelector(state => selectListDefaultOptions(state, 'countries'));

  const { match } = useRouter();
  const { path } = match;
  const isMapView = path?.includes('map');

  const portAreaValue = useMemo(() => {
    return _get(
      topFilters.find(f => f.name === 'port_area_id'),
      'value'
    );
  }, [topFilters]);

  const countryValue = useMemo(() => {
    return _get(
      topFilters.find(f => f.name === 'country_id'),
      'value'
    );
  }, [topFilters]);

  const updateTopFilters = useCallback(
    (key, value, operation) => {
      setTopFilters(
        topFilters.map(f =>
          f.name === key ? { ...f, value: value, operation: operation || f.operation } : f
        )
      );
    },
    [topFilters, setTopFilters]
  );

  const modifyOptions = async (search, list, text) => {
    const listOptions = search
      ? await getAsyncOptions(search, list)
      : await getInitialAsyncValues(list, null, null);

    const modifiedListOptions = [
      text === 'area' ? portNoAreaOption : portNoCountryOption,
      ...listOptions
    ];

    return modifiedListOptions;
  };

  const onChange = (value, field) => {
    if (value?.name?.includes('no')) {
      return updateTopFilters(field, value.id);
    } else {
      updateTopFilters(field, value?.id ? [value.id] : null);
    }
  };

  return (
    <Row className={`align-items-center ${isMapView ? 'w-100p' : ''}`}>
      <Col xs={'auto'} className="d-flex align-items-center">
        <NavigationGroupTabs
          tabs={[
            {
              label: 'List View',
              to: `${paths.enums.ports}`,
              tooltip: 'List View',
              icon: menuIcon
            },
            {
              label: 'Map View',
              to: `${paths.enums.ports_map}`,
              tooltip: 'Map View',
              icon: environmental
            }
          ]}
        />
        <div className={`small-separator ${isMapView ? 'ms-2' : 'mx-2'} py-1`}></div>
      </Col>

      {isMapView ? (
        <>
          <Col xs={2}>
            <Select
              isAsync
              className={'mb-0'}
              loadOptions={search => modifyOptions(search, 'countries', 'country')}
              defaultOptions={() => modifyOptions(null, 'countries', 'country')}
              onChange={value => onChange(value, 'country_id')}
              value={
                countryValue?.includes(portNoCountryOption?.id)
                  ? portNoCountryOption
                  : countrieslistOptions?.find(a => a.id == countryValue?.[0])
              }
              getOptionValue={option => option.code}
              getOptionLabel={option => option.name || option.title}
              placeholder="Select Country"
              isMulti={false}
              isClearable={true}
            />
          </Col>

          <Col xs={2}>
            <Select
              isAsync
              className={'mb-0'}
              loadOptions={search => modifyOptions(search, 'port-areas', 'area')}
              defaultOptions={() => modifyOptions(null, 'port-areas', 'area')}
              onChange={value => onChange(value, 'port_area_id')}
              getOptionValue={option => option.id}
              getOptionLabel={option => option.name || option.title}
              value={
                portAreaValue?.includes(portNoAreaOption?.id)
                  ? portNoAreaOption
                  : areaslistOptions?.find(a => a.id == portAreaValue?.[0])
              }
              placeholder="Select Area"
              isMulti={false}
              isClearable={true}
            />
          </Col>

          <Col className="d-flex justify-content-end">
            <TableSearchText label={'ports_map'} />
          </Col>
        </>
      ) : null}
    </Row>
  );
};

export default TopFilters;
